import React, { FC } from 'react'
import { PopconfirmProps } from 'antd/lib/popconfirm'
import {
	UIHtmlType,
	UIPlacement,
	UISizes,
	UITypes,
	getPopConfirm,
	TooltipComponent,
	i18n,
} from 'LibNeo'
import { AutoTestsProps } from 'Types/autoTests'
import { WrapperIcon, HrefBtn, LinkBtn, Button } from './styled'

export interface BtnProps extends AutoTestsProps {
	size?: UISizes
	type?: UITypes
	block?: boolean
	disabled?: boolean
	outline?: boolean // bordered
	className?: string
	onClick?: (e: any) => void
	popConfirmProps?: PopconfirmProps
	link?: boolean // кнопка в виде ссылки
	href?: string // href ссылка на внеший ресурс
	url?: string // ссылка для SPA роутинга
	icon?: string // иконка слева
	iconAction?: string // иконка справа
	tooltip?: string | JSX.Element
	tooltipPlacement?: UIPlacement
	title?: string | JSX.Element
	htmlType?: UIHtmlType
	indicator?: boolean // красный маленький кружок в правом верхнем углу
	defaultVisibleTooltip?: boolean
}

export const BtnComponent: FC<BtnProps> = ({
	title,
	disabled = false, // гарантирует появление атрибута data-qa-disabled, ввиду типа boolean | undef
	size = UISizes.NORMAL,
	outline,
	className,
	onClick,
	type = UITypes.PRIMARY,
	link,
	href,
	tooltip,
	tooltipPlacement,
	icon,
	iconAction,
	block,
	popConfirmProps,
	dataQa,
	htmlType = UIHtmlType.BUTTON,
	url,
	indicator = false,
	defaultVisibleTooltip,
}) => {
	const propsBtn = {
		types: type,
		size,
		left: Boolean(icon && !iconAction && title),
		right: Boolean(iconAction && !icon && title),
		icons: Boolean(iconAction && icon),
		iconOnly: Boolean(!title),
		outline,
		link,
		disabled,
		block,
		withIndicator: indicator && Boolean(icon || iconAction),
	}
	const iconComponent = icon && (
		<WrapperIcon
			type={type}
			name={icon}
			size={UISizes.SMALL}
			withIndicator={indicator && (icon || iconAction)}
			left={icon && !iconAction && title}
			right={iconAction && !icon && title}
			icons={iconAction && icon}
		/>
	)
	const iconActionComponent = iconAction && (
		<WrapperIcon
			type={type}
			name={iconAction}
			size={UISizes.SMALL}
			withIndicator={indicator && (icon || iconAction)}
			left={icon && !iconAction && title}
			right={iconAction && !icon && title}
			icons={iconAction && icon}
		/>
	)

	const disabledOnClick = (e): void => {
		e.stopPropagation()
		e.preventDefault()
	}

	const getButton = (): JSX.Element => {
		const qaData = dataQa || `${type}-button`
		const children = (
			<>
				{iconComponent}
				{typeof title === 'string' ? i18n(title) : title}
				{iconActionComponent}
			</>
		)
		let button
		if (href) {
			button = (
				<HrefBtn
					{...propsBtn}
					data-qa={qaData}
					className={className}
					href={href}
					target="_blank"
					rel="noopener noreferrer"
					onClick={disabled ? disabledOnClick : undefined}
				>
					{children}
				</HrefBtn>
			)
		} else if (url) {
			button = (
				<LinkBtn
					{...propsBtn}
					to={url}
					data-qa={qaData}
					className={className}
					onClick={disabled ? disabledOnClick : undefined}
				>
					{children}
				</LinkBtn>
			)
		} else {
			button = (
				<Button
					{...propsBtn}
					data-qa={qaData}
					data-qa-disabled={disabled}
					className={className}
					onClick={disabled ? disabledOnClick : onClick}
					type={htmlType}
				>
					{children}
				</Button>
			)
		}

		return (
			<>
				{tooltip ? (
					<TooltipComponent
						defaultVisible={defaultVisibleTooltip}
						title={tooltip}
						placement={tooltipPlacement}
					>
						{getPopConfirm(button, popConfirmProps, disabled)}
					</TooltipComponent>
				) : (
					getPopConfirm(button, popConfirmProps, disabled)
				)}
			</>
		)
	}

	return getButton()
}
